import React from "react";

import metaPixel from "../../utils/metaPixel";
import CookieConsent from "../../utils/CookieConsent";

// Pixel afiliacyjny startuje dopiero po zgodzie marketingowej (od razu, jeśli była wyrażona
// wcześniej, albo w momencie zapisania jej w banerze CookiesInfo).
export default function useMetaPixel(sellerCode) {
    const pixelId = metaPixel.getPixelId(sellerCode);
    const [marketingConsent, setMarketingConsent] = React.useState(CookieConsent.hasMarketingConsent);

    React.useEffect(() => {
        return CookieConsent.onChange(() => setMarketingConsent(CookieConsent.hasMarketingConsent()));
    }, []);

    React.useEffect(() => {
        if (pixelId && marketingConsent) {
            metaPixel.init(pixelId);
        }
    }, [pixelId, marketingConsent]);
}
